import _post from "./NoBodyPost"
import constantURI from "../URI"
import {WMSDB} from "../ConstantURI"

const WMSAuthenticate = async () => {
    var result = false;
    const token = JSON.parse(localStorage.getItem("Token"));
    const user = JSON.parse(localStorage.getItem("Username"));
    const url = constantURI() + "Authentication?token=" + token + "&user=" + user + "&username=" + "admin" + "&password=" + "admin" + "&db=" + WMSDB;
    if (navigator.onLine) {
        setTimeout(await _post(url).then((response) => {
            return response.json().then((data) => {
                if (data.result === undefined) {
                    result = false;
                } else if (data === {Message: "An error has occurred."}) {
                    result = "";
                } else result = true;
            })
        }), 30000);
    } else {
        result = false;
    }
    return result;
}
export default WMSAuthenticate;


